import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';
import Markdown from 'preact-markdown';

// Drawer behind the "Hva gjør jeg nå?" button on the frontpage critical-tasks card.
// The backend recomputes the clinic's alerts, asks the AI-assistent module for a
// prioritized plan and bills one call on the user; unchanged counts are served from
// the 30-day cache for free (data.fromCache).
@observer
class CriticalTasksAdvice extends Component {
    componentDidMount() {
        const { saleStore } = this.props.stores;
        saleStore.loadCriticalTasksAdvice();
    }

    onClickRefresh = () => {
        const { saleStore } = this.props.stores;
        saleStore.loadCriticalTasksAdvice({ skipCache: true });
    }

    render() {
        const { saleStore } = this.props.stores;
        const loading = saleStore.criticalTasksAdviceLoading;
        const data = saleStore.criticalTasksAdvice || {};
        const {
            output_text: outputText = '', error = null, fromCache = false, alerts = [],
        } = data;

        return (
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100 h-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>

                    <div class='font-weight-lighter px-3 box-header d-flex flex-row align-items-center justify-content-between'>
                        <div>
                            <i class='fa-duotone fa-wand-magic-sparkles me-2' />
                            <Text id='criticalTasks.adviceTitle'>What should I do now?</Text>
                        </div>
                        <button
                            type='button'
                            class='btn btn-sm btn-outline-secondary rounded-pill py-0'
                            onClick={this.onClickRefresh}
                            disabled={loading}
                        >
                            <i class={`fa-solid fa-arrows-rotate ${loading ? 'fa-spin' : ''}`} />
                            {' '}
                            <Text id='criticalTasks.adviceRefresh'>Get a new answer</Text>
                        </button>
                    </div>

                    <div class='px-3 mt-2'>
                        <small class='text-body-secondary'>
                            <i class='fa-solid fa-circle-info me-1' />
                            <Text id='criticalTasks.adviceIntro'>The AI assistant turns the critical tasks on the frontpage into a prioritized plan. Each new plan is billed per request. Unchanged numbers give the same answer at no extra cost.</Text>
                        </small>
                    </div>

                    {fromCache && !loading && (
                        <div class='px-3 mt-2'>
                            <small class='text-body-secondary'>
                                <i class='fa-solid fa-database me-1' />
                                <Text id='criticalTasks.adviceFromCache'>Same numbers as last time, answer reused from earlier (not billed)</Text>
                            </small>
                        </div>
                    )}

                    {alerts.length > 0 && (
                        <div class='px-3 mt-3 d-flex flex-wrap gap-2'>
                            {alerts.map(a => (
                                <span key={a.key} class={`badge bg-${a.severity || 'warning'}-subtle text-${a.severity || 'warning'}-emphasis rounded-pill`}>
                                    <Text id={`criticalTasks.${a.key}`}>{a.key}</Text>: {a.count}
                                </span>
                            ))}
                        </div>
                    )}

                    <div class='px-3 py-3'>
                        {loading && (
                            <div class='d-flex flex-column align-items-center justify-content-center py-5'>
                                <i class='fa-solid fa-spinner fa-spin fa-2x mb-3' />
                                <div class='text-body-secondary'>
                                    <Text id='criticalTasks.adviceLoading'>Working out a plan ...</Text>
                                </div>
                            </div>
                        )}

                        {!loading && error && (
                            <div class='alert alert-danger'>
                                <i class='fa-solid fa-triangle-exclamation me-2' />
                                {error}
                            </div>
                        )}

                        {!loading && outputText && (
                            <div class='card'>
                                <div class='card-body'>
                                    <Markdown markdown={outputText} />
                                </div>
                            </div>
                        )}

                        {!loading && (
                            <div class='mt-3'>
                                <small class='text-body-secondary'>
                                    <i class='fa-solid fa-triangle-exclamation me-1' />
                                    <Text id='criticalTasks.adviceDisclaimer'>AI-generated suggestion. Always check it against the numbers on the frontpage and in the sales list.</Text>
                                </small>
                            </div>
                        )}
                    </div>

                </div>
            </div>
        );
    }
}

export default CriticalTasksAdvice;
